//import the Polymer library
import { PolymerElement, html } from "@polymer/polymer/polymer-element.js";
import "@polymer/polymer/lib/elements/dom-if.js";
import "@polymer/polymer/lib/elements/dom-repeat.js";

import paperPlane from "../../../images/icons/paper_plane.svg";

class LiveChatBox extends PolymerElement {
  static get template() {
    return html`
    <style>
      .chat-box-container {
        display: flex !important;
        flex-direction: column !important;
        height: 414px;
        border: 1px solid #DADEE4;
        padding: 16px 4px 16px 16px;
        margin-bottom: 15px;
        color: #424242;
        border-radius: 4px;
      }
      .chat-box-title {
        margin: 0 0 10px 0;
        color: black;
      }
      .bubble-container {
        height: 330px;
        width: 290px;
        overflow: auto;
        margin-bottom: 20px;
      }
      .bubble {
        margin: 0 12px 5px 0;
      }
      .bubble-top {
        display: flex;
        justify-content: space-between;
      }
      .person-name {
        font-weight: 700;
        width: 250px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .chat-field {
        -webkit-font-smoothing: antialiased;
        font-family: "Lato", sans-serif;
        font-weight: 400;
        box-sizing: unset;
        margin: 0;
        height: 40px;
        line-height: 38px;
        border: 1px solid #BCBCBC;
        display: flex;
        font-size: 14px;
        background-color: inherit;
        color: #424242;
        background-repeat: no-repeat;
        background-position: 250px center;
        background-size: 16.5px;
        padding: 0px 7px 0px 17px;
        border-radius: 25px;
        margin-right: 12px;
      }
      .chat-field input {
        border: none;
        padding: 0;
        height: 100%;
        width: 100%;
      }
      .chat-field input:focus{
        outline: none;
      }
      .chat-field button {
        border: none;
        background: none;
        cursor: pointer;
      }
      ::-webkit-scrollbar {
        width: 5px;
      }
      ::-webkit-scrollbar-thumb {
        background: #ECECEC; 
        border-radius:10px;
      }
      ::-webkit-scrollbar-thumb:hover {
        background: #555; 
      } 
    </style>
    <div class="chat-box-container" >
      <h3 class="chat-box-title" >Live QnA</h3>
      <div class="bubble-container" id="scrollable_chat_container">
        <dom-repeat items="{{listChat}}" as="chatItem">
          <template>
            <div class="bubble" >
              <div class="bubble-top" >
                <span class="person-name" >{{chatItem.doctor_name}}</span>
                <span>{{_getTime(chatItem.created_at)}}</span>
              </div>
              <div>{{chatItem.question}}</div>
            </div>
          </template>
        </dom-repeat>
      </div>
      <div class="chat-field">
        <input id="live_chat_msg_content" placeholder="Tulis Pesan" />
        <button on-click="_handleSendMsg" ><img src="[[paperPlane]]" alt="Send" />
      </div>
    </div>  
    `;
  }

  static get properties() {
    return {
      paperPlane: {
        type: String,
        value: paperPlane,
      },
      listChat: {
        type: Array,
        notify: true,
      },
      _getTime: {
        type: Function,
        value: () => (s) => s.split(" ")[1],
      },
      isConnect: {
        type: Boolean,
        value: false,
        notify: true,
      },
    };
  }

  _handleSendMsg() {
    let msgInput = this.shadowRoot.querySelector("#live_chat_msg_content");
    if (msgInput.value.length > 0)
      this.dispatchEvent(
        new CustomEvent("tap-send-msg", {
          detail: { message: msgInput.value },
        })
      );
    if (this.isConnect) msgInput.value = "";
  }

  ready() {
    super.ready();
    const self = this;
    this.shadowRoot.querySelector("#live_chat_msg_content").addEventListener("keyup", (e) => {
      if (e.keyCode === 13) self._handleSendMsg();
    }); // send message by pressing enter
  }
}
customElements.define("live-chat-box", LiveChatBox);
